module.exports = {
  currencyMap: {
    USD: { code: 'en-us', currency: 'USD' },
    INR: { code: 'en-in', currency: 'INR' },
    EUR: { code: 'en-eu', currency: 'EUR' },
    BRL: { code: 'en-us', currency: 'BRL' },
    AED: { code: 'en-us', currency: 'AED' },
    AFN: { code: 'en-us', currency: 'AFN' },
    ALL: { code: 'en-us', currency: 'ALL' },
    AMD: { code: 'en-us', currency: 'AMD' },
    ANG: { code: 'en-us', currency: 'ANG' },
    AOA: { code: 'en-us', currency: 'AOA' },
    ARS: { code: 'en-us', currency: 'ARS' },
    AUD: { code: 'en-us', currency: 'AUD' },
    AWG: { code: 'en-us', currency: 'AWG' },
    AZN: { code: 'en-us', currency: 'AZN' },
    BAM: { code: 'en-us', currency: 'BAM' },
    BBD: { code: 'en-us', currency: 'BBD' },
    BDT: { code: 'en-us', currency: 'BDT' },
    BGN: { code: 'en-us', currency: 'BGN' },
    BHD: { code: 'en-us', currency: 'BHD' },
    BIF: { code: 'en-us', currency: 'BIF' },
    BMD: { code: 'en-us', currency: 'BMD' },
    BND: { code: 'en-us', currency: 'BND' },
    BOB: { code: 'en-us', currency: 'BOB' },
    BSD: { code: 'en-us', currency: 'BSD' },
    BTN: { code: 'en-us', currency: 'BTN' },
    BWP: { code: 'en-us', currency: 'BWP' },
    BYN: { code: 'en-us', currency: 'BYN' },
    BYR: { code: 'en-us', currency: 'BYR' },
    BZD: { code: 'en-us', currency: 'BZD' },
    CAD: { code: 'en-us', currency: 'CAD' },
    CDF: { code: 'en-us', currency: 'CDF' },
    CHF: { code: 'en-us', currency: 'CHF' },
    CLP: { code: 'en-us', currency: 'CLP' },
    CNY: { code: 'en-us', currency: 'CNY' },
    COP: { code: 'en-us', currency: 'COP' },
    CRC: { code: 'en-us', currency: 'CRC' },
    CUC: { code: 'en-us', currency: 'CUC' },
    CUP: { code: 'en-us', currency: 'CUP' },
    CVE: { code: 'en-us', currency: 'CVE' },
    CZK: { code: 'en-us', currency: 'CZK' },
    DJF: { code: 'en-us', currency: 'DJF' },
    DKK: { code: 'en-us', currency: 'DKK' },
    DOP: { code: 'en-us', currency: 'DOP' },
    DZD: { code: 'en-us', currency: 'DZD' },
    EGP: { code: 'en-us', currency: 'EGP' },
    ERN: { code: 'en-us', currency: 'ERN' },
    ETB: { code: 'en-us', currency: 'ETB' },
    FJD: { code: 'en-us', currency: 'FJD' },
    FKP: { code: 'en-us', currency: 'FKP' },
    GBP: { code: 'en-us', currency: 'GBP' },
    GEL: { code: 'en-us', currency: 'GEL' },
    GHS: { code: 'en-us', currency: 'GHS' },
    GIP: { code: 'en-us', currency: 'GIP' },
    GMD: { code: 'en-us', currency: 'GMD' },
    GNF: { code: 'en-us', currency: 'GNF' },
    GTQ: { code: 'en-us', currency: 'GTQ' },
    GYD: { code: 'en-us', currency: 'GYD' },
    HKD: { code: 'en-us', currency: 'HKD' },
    HNL: { code: 'en-us', currency: 'HNL' },
    HRK: { code: 'en-us', currency: 'HRK' },
    HTG: { code: 'en-us', currency: 'HTG' },
    HUF: { code: 'en-us', currency: 'HUF' },
    IDR: { code: 'en-us', currency: 'IDR' },
    ILS: { code: 'en-us', currency: 'ILS' },
    IQD: { code: 'en-us', currency: 'IQD' },
    IRR: { code: 'en-us', currency: 'IRR' },
    ISK: { code: 'en-us', currency: 'ISK' },
    JMD: { code: 'en-us', currency: 'JMD' },
    JOD: { code: 'en-us', currency: 'JOD' },
    JPY: { code: 'en-us', currency: 'JPY' },
    KES: { code: 'en-us', currency: 'KES' },
    KGS: { code: 'en-us', currency: 'KGS' },
    KHR: { code: 'en-us', currency: 'KHR' },
    KMF: { code: 'en-us', currency: 'KMF' },
    KPW: { code: 'en-us', currency: 'KPW' },
    KRW: { code: 'en-us', currency: 'KRW' },
    KWD: { code: 'en-us', currency: 'KWD' },
    KYD: { code: 'en-us', currency: 'KYD' },
    KZT: { code: 'en-us', currency: 'KZT' },
    LAK: { code: 'en-us', currency: 'LAK' },
    LBP: { code: 'en-us', currency: 'LBP' },
    LKR: { code: 'en-us', currency: 'LKR' },
    LRD: { code: 'en-us', currency: 'LRD' },
    LSL: { code: 'en-us', currency: 'LSL' },
    LYD: { code: 'en-us', currency: 'LYD' },
    MAD: { code: 'en-us', currency: 'MAD' },
    MDL: { code: 'en-us', currency: 'MDL' },
    MGA: { code: 'en-us', currency: 'MGA' },
    MKD: { code: 'en-us', currency: 'MKD' },
    MMK: { code: 'en-us', currency: 'MMK' },
    MNT: { code: 'en-us', currency: 'MNT' },
    MOP: { code: 'en-us', currency: 'MOP' },
    MRO: { code: 'en-us', currency: 'MRO' },
    MUR: { code: 'en-us', currency: 'MUR' },
    MVR: { code: 'en-us', currency: 'MVR' },
    MWK: { code: 'en-us', currency: 'MWK' },
    MXN: { code: 'en-us', currency: 'MXN' },
    MYR: { code: 'en-us', currency: 'MYR' },
    MZN: { code: 'en-us', currency: 'MZN' },
    NAD: { code: 'en-us', currency: 'NAD' },
    NGN: { code: 'en-us', currency: 'NGN' },
    NIO: { code: 'en-us', currency: 'NIO' },
    NOK: { code: 'en-us', currency: 'NOK' },
    NPR: { code: 'en-us', currency: 'NPR' },
    NZD: { code: 'en-us', currency: 'NZD' },
    OMR: { code: 'en-us', currency: 'OMR' },
    PAB: { code: 'en-us', currency: 'PAB' },
    PEN: { code: 'en-us', currency: 'PEN' },
    PGK: { code: 'en-us', currency: 'PGK' },
    PHP: { code: 'en-us', currency: 'PHP' },
    PKR: { code: 'en-in', currency: 'PKR' },
    PLN: { code: 'en-us', currency: 'PLN' },
    PYG: { code: 'en-us', currency: 'PYG' },
    QAR: { code: 'en-us', currency: 'QAR' },
    RON: { code: 'en-us', currency: 'RON' },
    RSD: { code: 'en-us', currency: 'RSD' },
    RUB: { code: 'en-us', currency: 'RUB' },
    RWF: { code: 'en-us', currency: 'RWF' },
    SAR: { code: 'en-us', currency: 'SAR' },
    SBD: { code: 'en-us', currency: 'SBD' },
    SCR: { code: 'en-us', currency: 'SCR' },
    SDG: { code: 'en-us', currency: 'SDG' },
    SEK: { code: 'en-us', currency: 'SEK' },
    SGD: { code: 'en-us', currency: 'SGD' },
    SHP: { code: 'en-us', currency: 'SHP' },
    SLL: { code: 'en-us', currency: 'SLL' },
    SOS: { code: 'en-us', currency: 'SOS' },
    SRD: { code: 'en-us', currency: 'SRD' },
    STD: { code: 'en-us', currency: 'STD' },
    SVC: { code: 'en-us', currency: 'SVC' },
    SYP: { code: 'en-us', currency: 'SYP' },
    SZL: { code: 'en-us', currency: 'SZL' },
    THB: { code: 'en-us', currency: 'THB' },
    TJS: { code: 'en-us', currency: 'TJS' },
    TMT: { code: 'en-us', currency: 'TMT' },
    TND: { code: 'en-us', currency: 'TND' },
    TOP: { code: 'en-us', currency: 'TOP' },
    TRY: { code: 'en-us', currency: 'TRY' },
    TTD: { code: 'en-us', currency: 'TTD' },
    TWD: { code: 'en-us', currency: 'TWD' },
    TZS: { code: 'en-us', currency: 'TZS' },
    UAH: { code: 'en-us', currency: 'UAH' },
    UGX: { code: 'en-us', currency: 'UGX' },
    UYU: { code: 'en-us', currency: 'UYU' },
    UZS: { code: 'en-us', currency: 'UZS' },
    VEF: { code: 'en-us', currency: 'VEF' },
    VND: { code: 'en-us', currency: 'VND' },
    VUV: { code: 'en-us', currency: 'VUV' },
    WST: { code: 'en-us', currency: 'WST' },
    XAF: { code: 'en-us', currency: 'XAF' },
    XCD: { code: 'en-us', currency: 'XCD' },
    XDR: { code: 'en-us', currency: 'XDR' },
    XOF: { code: 'en-us', currency: 'XOF' },
    XPF: { code: 'en-us', currency: 'XPF' },
    YER: { code: 'en-us', currency: 'YER' },
    ZAR: { code: 'en-us', currency: 'ZAR' },
    ZMW: { code: 'en-us', currency: 'ZMW' },
    ZWL: { code: 'en-us', currency: 'ZWL' },
    8: { code: 'en-us', currency: 'ALL' },
    12: { code: 'en-us', currency: 'DZD' },
    32: { code: 'en-us', currency: 'ARS' },
    36: { code: 'en-us', currency: 'AUD' },
    44: { code: 'en-us', currency: 'BSD' },
    48: { code: 'en-us', currency: 'BHD' },
    50: { code: 'en-us', currency: 'BDT' },
    51: { code: 'en-us', currency: 'AMD' },
    52: { code: 'en-us', currency: 'BBD' },
    60: { code: 'en-us', currency: 'BMD' },
    64: { code: 'en-us', currency: 'BTN' },
    68: { code: 'en-us', currency: 'BOB' },
    72: { code: 'en-us', currency: 'BWP' },
    84: { code: 'en-us', currency: 'BZD' },
    90: { code: 'en-us', currency: 'SBD' },
    96: { code: 'en-us', currency: 'BND' },
    104: { code: 'en-us', currency: 'MMK' },
    108: { code: 'en-us', currency: 'BIF' },
    116: { code: 'en-us', currency: 'KHR' },
    124: { code: 'en-us', currency: 'CAD' },
    132: { code: 'en-us', currency: 'CVE' },
    136: { code: 'en-us', currency: 'KYD' },
    144: { code: 'en-us', currency: 'LKR' },
    152: { code: 'en-us', currency: 'CLP' },
    156: { code: 'en-us', currency: 'CNY' },
    170: { code: 'en-us', currency: 'COP' },
    174: { code: 'en-us', currency: 'KMF' },
    188: { code: 'en-us', currency: 'CRC' },
    191: { code: 'en-us', currency: 'HRK' },
    192: { code: 'en-us', currency: 'CUP' },
    203: { code: 'en-us', currency: 'CZK' },
    208: { code: 'en-us', currency: 'DKK' },
    214: { code: 'en-us', currency: 'DOP' },
    222: { code: 'en-us', currency: 'SVC' },
    230: { code: 'en-us', currency: 'ETB' },
    232: { code: 'en-us', currency: 'ERN' },
    238: { code: 'en-us', currency: 'FKP' },
    242: { code: 'en-us', currency: 'FJD' },
    262: { code: 'en-us', currency: 'DJF' },
    270: { code: 'en-us', currency: 'GMD' },
    292: { code: 'en-us', currency: 'GIP' },
    320: { code: 'en-us', currency: 'GTQ' },
    324: { code: 'en-us', currency: 'GNF' },
    328: { code: 'en-us', currency: 'GYD' },
    332: { code: 'en-us', currency: 'HTG' },
    340: { code: 'en-us', currency: 'HNL' },
    344: { code: 'en-us', currency: 'HKD' },
    348: { code: 'en-us', currency: 'HUF' },
    352: { code: 'en-us', currency: 'ISK' },
    356: { code: 'en-in', currency: 'INR' },
    360: { code: 'en-us', currency: 'IDR' },
    364: { code: 'en-us', currency: 'IRR' },
    368: { code: 'en-us', currency: 'IQD' },
    376: { code: 'en-us', currency: 'ILS' },
    388: { code: 'en-us', currency: 'JMD' },
    392: { code: 'en-us', currency: 'JPY' },
    398: { code: 'en-us', currency: 'KZT' },
    400: { code: 'en-us', currency: 'JOD' },
    404: { code: 'en-us', currency: 'KES' },
    408: { code: 'en-us', currency: 'KPW' },
    410: { code: 'en-us', currency: 'KRW' },
    414: { code: 'en-us', currency: 'KWD' },
    417: { code: 'en-us', currency: 'KGS' },
    418: { code: 'en-us', currency: 'LAK' },
    422: { code: 'en-us', currency: 'LBP' },
    426: { code: 'en-us', currency: 'LSL' },
    430: { code: 'en-us', currency: 'LRD' },
    434: { code: 'en-us', currency: 'LYD' },
    446: { code: 'en-us', currency: 'MOP' },
    454: { code: 'en-us', currency: 'MWK' },
    458: { code: 'en-us', currency: 'MYR' },
    462: { code: 'en-us', currency: 'MVR' },
    478: { code: 'en-us', currency: 'MRO' },
    480: { code: 'en-us', currency: 'MUR' },
    484: { code: 'en-us', currency: 'MXN' },
    496: { code: 'en-us', currency: 'MNT' },
    498: { code: 'en-us', currency: 'MDL' },
    504: { code: 'en-us', currency: 'MAD' },
    512: { code: 'en-us', currency: 'OMR' },
    516: { code: 'en-us', currency: 'NAD' },
    524: { code: 'en-us', currency: 'NPR' },
    532: { code: 'en-us', currency: 'ANG' },
    533: { code: 'en-us', currency: 'AWG' },
    548: { code: 'en-us', currency: 'VUV' },
    554: { code: 'en-us', currency: 'NZD' },
    558: { code: 'en-us', currency: 'NIO' },
    566: { code: 'en-us', currency: 'NGN' },
    578: { code: 'en-us', currency: 'NOK' },
    586: { code: 'en-in', currency: 'PKR' },
    590: { code: 'en-us', currency: 'PAB' },
    598: { code: 'en-us', currency: 'PGK' },
    600: { code: 'en-us', currency: 'PYG' },
    604: { code: 'en-us', currency: 'PEN' },
    608: { code: 'en-us', currency: 'PHP' },
    634: { code: 'en-us', currency: 'QAR' },
    643: { code: 'en-us', currency: 'RUB' },
    646: { code: 'en-us', currency: 'RWF' },
    654: { code: 'en-us', currency: 'SHP' },
    678: { code: 'en-us', currency: 'STD' },
    682: { code: 'en-us', currency: 'SAR' },
    690: { code: 'en-us', currency: 'SCR' },
    694: { code: 'en-us', currency: 'SLL' },
    702: { code: 'en-us', currency: 'SGD' },
    704: { code: 'en-us', currency: 'VND' },
    706: { code: 'en-us', currency: 'SOS' },
    710: { code: 'en-us', currency: 'ZAR' },
    748: { code: 'en-us', currency: 'SZL' },
    752: { code: 'en-us', currency: 'SEK' },
    756: { code: 'en-us', currency: 'CHF' },
    760: { code: 'en-us', currency: 'SYP' },
    764: { code: 'en-us', currency: 'THB' },
    776: { code: 'en-us', currency: 'TOP' },
    780: { code: 'en-us', currency: 'TTD' },
    784: { code: 'en-us', currency: 'AED' },
    788: { code: 'en-us', currency: 'TND' },
    800: { code: 'en-us', currency: 'UGX' },
    807: { code: 'en-us', currency: 'MKD' },
    818: { code: 'en-us', currency: 'EGP' },
    826: { code: 'en-us', currency: 'GBP' },
    834: { code: 'en-us', currency: 'TZS' },
    840: { code: 'en-us', currency: 'USD' },
    858: { code: 'en-us', currency: 'UYU' },
    860: { code: 'en-us', currency: 'UZS' },
    882: { code: 'en-us', currency: 'WST' },
    886: { code: 'en-us', currency: 'YER' },
    901: { code: 'en-us', currency: 'TWD' },
    931: { code: 'en-us', currency: 'CUC' },
    932: { code: 'en-us', currency: 'ZWL' },
    933: { code: 'en-us', currency: 'BYN' },
    934: { code: 'en-us', currency: 'TMT' },
    936: { code: 'en-us', currency: 'GHS' },
    937: { code: 'en-us', currency: 'VEF' },
    938: { code: 'en-us', currency: 'SDG' },
    941: { code: 'en-us', currency: 'RSD' },
    943: { code: 'en-us', currency: 'MZN' },
    944: { code: 'en-us', currency: 'AZN' },
    946: { code: 'en-us', currency: 'RON' },
    949: { code: 'en-us', currency: 'TRY' },
    950: { code: 'en-us', currency: 'XAF' },
    951: { code: 'en-us', currency: 'XCD' },
    952: { code: 'en-us', currency: 'XOF' },
    953: { code: 'en-us', currency: 'XPF' },
    960: { code: 'en-us', currency: 'XDR' },
    967: { code: 'en-us', currency: 'ZMW' },
    968: { code: 'en-us', currency: 'SRD' },
    969: { code: 'en-us', currency: 'MGA' },
    971: { code: 'en-us', currency: 'AFN' },
    972: { code: 'en-us', currency: 'TJS' },
    973: { code: 'en-us', currency: 'AOA' },
    974: { code: 'en-us', currency: 'BYR' },
    975: { code: 'en-us', currency: 'BGN' },
    976: { code: 'en-us', currency: 'CDF' },
    977: { code: 'en-us', currency: 'BAM' },
    978: { code: 'en-eu', currency: 'EUR' },
    980: { code: 'en-us', currency: 'UAH' },
    981: { code: 'en-us', currency: 'GEL' },
    985: { code: 'en-us', currency: 'PLN' },
    986: { code: 'en-us', currency: 'BRL' },
  },
};
